// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3112cc76","658":"f91f6f88","718":"3056df29","816":"b0ffd0c5","874":"77fece2f","894":"bb3fc21d"}[chunkId] + ".chunk.js";
};